import { isOneOfRegions, isRegion, REGIONS } from './region'

export function getAvailablePhoneCountries(phoneCountries = [], region) {
  if (!isRegion(region, REGIONS.HK)) return phoneCountries

  return phoneCountries.filter((country) => isOneOfRegions(country.a2, [REGIONS.HK, REGIONS.TW]))
}

export default {
  getAvailablePhoneCountries,
}
